import React from "react";
import GMPHeader from "../../../components/Compliance Certificates/GMP/GMPHeader";
import GMPInfoContainer from "../../../components/Compliance Certificates/GMP/GMPInfoContainer";

const GMP = () => {
  return (
    <div>
      <GMPHeader />
      <GMPInfoContainer />
    </div>
  );
};

export default GMP;
